import React, { useEffect, useState } from 'react'
import { Button, Icon, Input, Loader, Menu } from 'semantic-ui-react'
import { theme } from '../../../theme'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { ACTIVITIES_BY_FILTERS, ACTIVITIES_BY_TERMS, LESSONS_BY_FILTERS, LESSONS_BY_TERMS } from '../../../query/activityQuery'
import { useLazyQuery } from '@apollo/client'
import { RoutingProductMap } from '../constants'
import { SPHERO } from '../../../constants'
import MobileResources from '../Pages/MobileResources'
import { onSaveQueryId } from '../../../redux/Activity/ActivityReducer'
import { useDispatch } from 'react-redux'

const LessonsList = ({ product }) => {
  const [lessons, setLessons] = useState([])
  const [loading, setLoading] = useState(false)
  const [query, setQuery] = useState('')

  const dispatch = useDispatch()

  const handleFilter = () => {
    if (query) handleAlgoliaLoad()
    else handleBasicLoad()
  }

  const handleSearchChange = (e, { value }) => {
    setQuery(value)
  }

  const handleKeyword = (event) => {
    if (event.key === 'Enter') {
      handleFilter()
    }
  }

  const [loadBasicLessons] = useLazyQuery(LESSONS_BY_FILTERS, {
    fetchPolicy: 'cache-and-network',
    onError (err) {
      console.error(err)
      setLoading(false)
    },
    onCompleted (payload) {
      const _activities = payload.lessonsByFilters
      setLessons(_activities?.lessons)
      setLoading(false)
    }
  })

  const [loadActivities] = useLazyQuery(ACTIVITIES_BY_FILTERS, {
    fetchPolicy: 'cache-and-network',
    onError (err) {
      console.error(err)
      setLoading(false)
    },
    onCompleted (payload) {
      const _activities = payload.activitiesByFilters
      setLessons(_activities?.activities)
      setLoading(false)
    }
  })

  const [loadAlgoliaLessons] = useLazyQuery(LESSONS_BY_TERMS, {
    fetchPolicy: 'cache-and-network',
    onError (err) {
      console.error(err)
      setLoading(false)
    },
    onCompleted (payload) {
      const _activities = payload.lessonsByTerms
      dispatch(onSaveQueryId({ lessonId: _activities?.queryId }))
      setLessons(_activities?.activities)
      setLoading(false)
    }
  })

  const [loadAlgoliaActivities] = useLazyQuery(ACTIVITIES_BY_TERMS, {
    fetchPolicy: 'cache-and-network',
    onError (err) {
      console.error(err)
      setLoading(false)
    },
    onCompleted (payload) {
      const _activities = payload.activitiesByTerms
      dispatch(onSaveQueryId({ activityId: _activities?.queryId }))
      setLessons(_activities?.activities)
      setLoading(false)
    }
  })

  const handleAlgoliaLoad = () => {
    const variables = {
      productLine: RoutingProductMap[product],
      searchTerm: query,
      page: 1,
      pageSize: 300
    }
    if (RoutingProductMap[product] === SPHERO) {
      loadAlgoliaActivities({ variables })
    } else {
      loadAlgoliaLessons({ variables })
    }
  }

  const handleBasicLoad = () => {
    const variables = {
      productLine: RoutingProductMap[product],
      page: 1,
      pageSize: 10
    }

    if (RoutingProductMap[product] === SPHERO) {
      loadActivities({ variables })
    } else {
      loadBasicLessons({ variables })
    }
  }

  useEffect(() => {
    handleBasicLoad()
  }, [])

  return (
    <div>
      <Input
        action={{ icon: 'search', color: 'blue', onClick: handleFilter }}
        placeholder='search'
        style={{ width: '100%', padding: '1rem 4rem' }}
        onChange={handleSearchChange}
        value={query}
      >
        <input
          style={{ borderRight: 'none' }}
          onKeyDown={(event) => { handleKeyword(event) }}
        />
        <Button color='blue' icon={<Icon name='search' color='white' />} onClick={handleFilter} />
      </Input>
      {loading
        ? <Loader />
        : (
          <ul style={{ overflow: 'auto' }}>
            {lessons.map(lesson => (
              <li key={lesson?.id}><a href={`/${product === 'edurobots' ? 'cwists/preview' : 'lessons'}/${lesson?.slug}`}>{lesson?.name}</a></li>
            ))}
          </ul>)}
    </div>
  )
}

const ResourcesList = ({ product }) => {
  return (
    <MobileResources productLine={RoutingProductMap[product]} />
  )
}

const LessonsAndResources = () => {
  const [activeTab, setActiveTab] = useState('lessons')
  const { robot } = useParams('robot')
  const { type } = useParams('type')

  const history = useHistory()

  useEffect(() => {
    if (type === 'resources') {
      history.push(`/${robot}/resources`)
    }
  }, [type])

  const handleTabClick = (e, { name }) => setActiveTab(name)

  return (
    <div>
      <Menu inverted borderless style={{ display: 'flex', justifyContent: 'center', backgroundColor: theme.dark.primary.default }}>
        <Menu.Item
          name='lessons'
          active={activeTab === 'lessons'}
          onClick={handleTabClick}
        >
          Lessons
        </Menu.Item>
        <Menu.Item
          name='resources'
          active={activeTab === 'resources'}
          onClick={handleTabClick}
        >
          Resources
        </Menu.Item>
      </Menu>
      {activeTab === 'lessons' ? <LessonsList product={robot} /> : <ResourcesList product={robot} />}
    </div>
  )
}

export default LessonsAndResources
